$(document).ready(function() {
    let $toggle = $('.sb-toggle');

    $toggle.on('click', function() {
        let target = $(this).data('target');
        target = $(target);
        toggleSidebar(target);
    });

    function toggleSidebar(target) {
        if (!target.hasClass('sb--visible')) {
            target.addClass('sb--visible');
        } else {
            target.removeClass('sb--visible');
        }
    }
});
